import type { OptionSetOverrides } from "building-types/options/optionTemplateTypes";
import objectIsEmpty from "common/utils/objectIsEmpty";

/**
 * Showroom Intro saves overrides at optionSetOverride.showroomIntroOverrides by default, to isolate changes to plans.
 * This function merges those overrides into optionSetOverride (for building gen) and removes the property showroomIntroOverrides.
 */
export default function mergeShowroomIntroOverrides(
  overrides: OptionSetOverrides | null | undefined,
): OptionSetOverrides | null | undefined {
  if (!overrides) {
    return overrides;
  }
  const newOverrides: OptionSetOverrides = {};
  for (const optionSetId in overrides) {
    const optionSetOverride = overrides[optionSetId];

    if (!optionSetOverride || objectIsEmpty(optionSetOverride)) {
      continue;
    }

    const { showroomIntroOverrides, options, ...override } = optionSetOverride;

    const { options: showroomIntroOptions, ...showroomIntroOverridesWithoutOptions } = showroomIntroOverrides || {};

    newOverrides[optionSetId] = {
      ...override,
      ...showroomIntroOverridesWithoutOptions,
    };

    // Merge option overrides from both optionSet.options and optionSet.showroomIntroOverrides.options.
    // The latter takes precedence.
    if (options) {
      for (const optionId in options) {
        const { showroomIntroOverrides, ...optionOverride } = options[optionId] || {};
        if (!newOverrides[optionSetId].options) {
          newOverrides[optionSetId].options = {};
        }
        newOverrides[optionSetId].options[optionId] = {
          ...newOverrides[optionSetId].options[optionId],
          ...optionOverride,
          ...showroomIntroOverrides,
        };
      }
    }
    if (showroomIntroOptions) {
      for (const optionId in showroomIntroOptions) {
        const { showroomIntroOverrides, ...optionOverride } = showroomIntroOptions[optionId] || {};
        if (!newOverrides[optionSetId].options) {
          newOverrides[optionSetId].options = {};
        }
        newOverrides[optionSetId].options[optionId] = {
          ...newOverrides[optionSetId].options[optionId],
          ...optionOverride,
          ...showroomIntroOverrides,
        };
      }
    }
  }

  return newOverrides;
}
